import React from 'react';
import { Controller, useForm } from 'react-hook-form';
import {
  Col,
  Form,
  Input,
  Label,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
} from 'reactstrap';
import { yupResolver } from '@hookform/resolvers/yup';
import { toast } from 'react-toastify';
import { useMutation } from '@tanstack/react-query';
import { useNavigate } from 'react-router-dom';
import {
  rejectBookingInitialValues,
  rejectBookingValidationSchema,
} from './constants';
import { rejectTravelBooking } from '../../../store/apis/travelService';

function RejectBookingModal({ isOpen, toggle, id, r, setRejectOption }) {
  const navigate = useNavigate();
  const {
    control,
    getValues,
    formState: { errors },
  } = useForm({
    defaultValues: rejectBookingInitialValues,
    resolver: yupResolver(rejectBookingValidationSchema),
    mode: 'onChange',
  });

  // Mutate function to handle rejection
  const { mutate: rejectMutation, isLoading: isRejecting } = useMutation({
    mutationFn: async payload => rejectTravelBooking(payload),
    onSuccess: response => {
      if (response?.flag === 'True') {
        toast.success('Booking request rejected successfully.', {
          className: 'toast-success',
        });
        setRejectOption('');
        navigate('/hr/booking-responsible');
      } else if (response?.flag === 'False') {
        toast.error(response?.message || 'Failed to reject booking request.', {
          className: 'toast-error',
        });
      }
    },
  });

  // Function to handle form submission
  const handleReject = async () => {
    const { reason } = getValues();
    if (!reason) {
      toast.error('Please provide a reason for rejection.', {
        className: 'toast-error',
      });
    } else {
      const payload = {
        reqNo: id,
        revisionNo: r,
        remarks: reason,
        cancelType: 'A',
      };
      rejectMutation(payload);
      setRejectOption('');
    }
  };

  return (
    <Modal isOpen={isOpen} toggle={toggle} centered size="md">
      <Form>
        <ModalHeader toggle={toggle}>Reject Booking Request</ModalHeader>
        <ModalBody>
          <Label for="rejectReason" className="fw-semibold">
            Reason for Rejection<span className="text-danger">*</span>
          </Label>
          <Controller
            control={control}
            name="reason"
            render={({ field }) => (
              <Input
                type="textarea"
                rows="4"
                {...field}
                placeholder="Enter Reason"
              />
            )}
          />
          {errors.reason && (
            <span className="text-danger">
              {errors.reason.message || 'Reason is required.'}
            </span>
          )}
        </ModalBody>
        <ModalFooter>
          <div className="d-flex flex-row gap-2 w-100">
            <Col className="w-100">
              <button
                type="button"
                className="custom-btn w-100"
                onClick={toggle}
              >
                Cancel
              </button>
            </Col>
            <Col className="w-100">
              <button
                type="button"
                className="custom-danger-btn w-100"
                onClick={() => handleReject()}
              >
                {isRejecting ? 'Rejecting...' : 'Reject'}
              </button>
            </Col>
          </div>
        </ModalFooter>
      </Form>
    </Modal>
  );
}

export default RejectBookingModal;
